export default class Modal extends React.Component {
    render() {
        return (
            <div style={this.getStyle()} className='modal'>
                {this.props.children}
            </div>
        );
    }

    getStyle() {
        return _.merge({
            position: 'absolute',
            backgroundColor: 'white',
            boxShadow: '0 0 20px rgba(0, 0, 0, 0.4)',
            zIndex: 3
        },
        this.props.style ? this.props.style : {});
    }

    componentDidMount() {
        this.centerModal();
    }

    centerModal() {
        let modalEl = document.querySelector('.modal');

        let modalHeight = window.getComputedStyle(modalEl).height.replace('px', '');
        let modalWidth = window.getComputedStyle(modalEl).width.replace('px', '');

        let windowHeight = window.innerHeight;
        let windowWidth = window.innerWidth;

        let topStyle = (windowHeight - modalHeight) / windowHeight * 100 / 2;
        let leftSTyle = (windowWidth - modalWidth) / windowWidth * 100 / 2;

        modalEl.style.top = (topStyle + '%');
        modalEl.style.left = (leftSTyle + '%');
    }
}
